module.exports = __webpack_public_path__ + "img/paypay.819c4b00.svg";